import { z } from 'zod'

export const HandbookLinkFormSchema = z.object({
  link: z
    .string()
    .min(1, 'Link is required.')
    .transform((val) => {
      let urlStr = val.trim()
      if (!/^https?:\/\//i.test(urlStr)) {
        urlStr = 'https://' + urlStr
      }

      return urlStr
    })
    .refine(
      (val) => {
        try {
          new URL(val)
          return true
        } catch {
          return false
        }
      },
      {
        message: 'Please enter a valid URL.',
      }
    ),
})
export type HandbookLinkFormValues = z.infer<typeof HandbookLinkFormSchema>
